import React, { Fragment, useState, useEffect } from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button,Select,MenuItem } from '@mui/material/';
import InputLabel from '@mui/material/InputLabel';
import axios from 'axios';
import Cookies from 'js-cookie'

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Autorize from '../../components/ui/autorize';
import { DataGrid, GridToolbar, frFR  } from '@mui/x-data-grid';

import { useParams } from 'react-router';

import RepportBySector from '../../components/reports/list_secteur';


//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function Reports() {

    const [errorAxios, setErrorAxios] = useState("false");
    const [autorize, setAutorize] = useState("false");

    const [dateDebut, setDateDebut] = useState("");
    const { myear } = useParams();
    const { myreport } = useParams();

    const [dateDebutTmp, setDateDebutTmp] = useState("");
    const [reportname, setreportname] = useState("");
    
    const [listClub, setListClub] = useState("");
    
    const [value, setValue] = React.useState(new Date());
    const [selectedDate, handleDateChange] = useState(new Date());
    const handleChange = (newValue) => {
      setValue(newValue);
    };


    const handleChangeDebut = (newValue) => {
        var d = new Date(newValue);
        var tt =  d.toISOString().split('T')[0]
        //console.log(d.getFullYear());
       // alert(tt);
         setDateDebutTmp(tt);
        setDateDebut(tt);
      };
  
    
   /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
const MyAxios = axios.create({    
    headers: { Authorization: "Bearer "+ Cookies.get('token'),
            }      
})

    useEffect(() => {

        if(autorize)
        {
            MyAxios.get(process.env.REACT_APP_API + '/rapports/getReportEffectifDetailOneDateSensitive/'+ dateDebut) //axios.defaults.withCredentials = true
            .then((res) => {      
                setErrorAxios(false);
                console.log(res);
                setListClub(res.data);
               
            })
            .catch((error) => {
                console.log(error)  
              ///  if(error.status)  
               //if(error.response.status === 401)// pas autorisé
                 setErrorAxios(true);   

            });


        }
       // setreportname('getreportEffectif');

      // console.log("LE CLUB est le : " + this.props.clubid)
      //setFormValue(clubid,this.props.clubid);
       //this.setState({clubid: this.props.clubid}); 
       //setDateDebutTmp(Date().getFullYear);
     //  handleDateChange(Date().getFullYear);
      //  setDateDebut(dateDebutTmp);


       }, [dateDebut,reportname]);
       
/*
   function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return year;
    }*/
    const handleChangeReports = (event) => {
        setreportname(event.target.value);
      };

      
      const columns = [           
        {      field: 'id',              headerName: 'id' ,        width: 0 ,     hide: true}  ,
        {      field: 'NoClub',          headerName: 'NoClub' ,        width: 100      }  ,
        {      field: 'ClubLegalName',   headerName: 'ClubLegalName' ,    width: 400 ,    }  ,       
        {      field: 'TotalMembreActif',      headerName: 'TotalMembreActif' ,    width: 160 ,    }  ,         
        {      field: 'MembreRegulier',     headerName: 'MembreRegulier' ,  width: 160 ,     }  ,
        {      field: 'MembreAVie',     headerName: 'MembreAVie' ,    width: 160 ,   }  ,               
        {      field: 'MembreCollegial',        headerName: 'MembreCollegial' ,    width: 160 ,      } ,
        {      field: 'AddThisMonth',        headerName: 'Ajout dans le mois' ,    width: 160 ,      }  ,
        {      field: 'President',       headerName: 'Président' ,    width: 250 ,    }  ,
        {      field: 'E_Mail_Address',  headerName: 'Président Email' ,    width: 275 ,    }  ,
        {      field: 'Address',         headerName: 'Président Address' ,    width: 250 ,    }  ,
        {      field: 'City',            headerName: 'Président City' ,    width: 250 ,    }  ,
        {      field: 'Postal_Code',     headerName: 'Président Postal_Code' ,    width: 250 ,    }  ,
        {      field: 'State_Province_Code',     headerName: 'Province' ,    width: 250 ,    }  ,
             
    ];




      function mainHtml()
      {
  
          if(autorize)
          {
              return (
                          <div style={{   width: '90%', margin: '3%' }}>
                        <Typography variant="h4" gutterBottom>
                            Rapport des effectifs détaillé en date du:
                        </Typography>

                        <Grid container direction="row" >
                            <Grid item xs={1} container direction="row" > 
                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='fr'> 

                                <DatePicker id="MyYear"
                                  
                                    label="Année Mois Jour"
                                    inputFormat="YYYY-MM-DD"
                                    value={dateDebutTmp}
                                    onChange={handleChangeDebut}
                                    renderInput={(params) => <TextField {...params} />}
                                    />

                                </LocalizationProvider>  
                            
                                </Grid>
                        
                                <Grid item xs={3} container direction="row" > 
                                                        
                            </Grid>                                            
                        </Grid>

                        <div style={{ height: '800px', width: '90%' }}> 
                        <DataGrid key="DataGridMember" localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                                    rows={listClub}
                                    columns={columns}
                                    pageSize={100}
                                    rowsPerPageOptions={[100]}                               
                                    components={{ Toolbar: GridToolbar }} 
                                                              
                                />

</div>

                    

                      </div>);
          }
          else
              return "";
  
      }
    
      const callbackAutoriser = (index) => { // the callback. Use a better name      
        setAutorize(index);     
      };
        

        return (
           <div>
                <Autorize axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>

                {mainHtml()}
                   
            </div>
            
        );
   
};

export default Reports;